var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.edit ? _c('side-card', {
    attrs: {
      "fullscreen": _vm.isMobile,
      "title": _vm.document.title,
      "height": _vm.sideCardHeight
    },
    on: {
      "close": function close($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return _vm._l(_vm.document.refs || [], function (ref) {
          return _c('go-to-reference-button', {
            key: 'reference' + ref.refId,
            attrs: {
              "reference": ref,
              "partnerId": _vm.partnerId
            }
          });
        });
      },
      proxy: true
    }, {
      key: "subtitle",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "subtitle mt-2",
          attrs: {
            "justify": "center",
            "align": "center"
          }
        }, [_vm._v(" " + _vm._s(_vm.subtitle) + " "), _c('v-spacer'), _c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_c('div', [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.isTemplate.".concat(_vm.document.isTemplate))) + " ")])])], 1)];
      },
      proxy: true
    }], null, false, 1391552454)
  }, [_c('div', {
    style: _vm.mainContainerStyle
  }, [_c('v-simple-table', [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.title")))]), _c('td', [_vm._v(_vm._s(_vm.document.title))])]), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.name")))]), _c('td', [_vm._v(_vm._s(_vm.document.name))])]), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.path")))]), _c('td', [_vm._v(_vm._s(_vm.document.folder))])]), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.tags")))]), _c('td', [_vm.document.tags.length ? _c('span', _vm._l(_vm.document.tags, function (tag) {
    return _c('v-chip', {
      key: 'tag' + tag,
      staticClass: "ml-1",
      attrs: {
        "small": ""
      }
    }, [_vm._v(" " + _vm._s(tag) + " ")]);
  }), 1) : _c('span', [_vm._v(" - ")])])])])]), _vm.document.description ? _c('v-card-text', {
    staticClass: "mt-1"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.document.description) + " ")])]) : _vm._e()], 1), _c('div', {
    staticClass: "ma-5 mb-3 mt-1"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "elevation": 0
    },
    on: {
      "click": function click($event) {
        _vm.edit = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailSave.edit")) + " ")])], 1)]) : _c('side-card', {
    attrs: {
      "fullscreen": _vm.isMobile,
      "height": _vm.sideCardHeight
    },
    on: {
      "close": function close($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('v-text-field', {
          staticClass: "mb-n7 mt-n2",
          model: {
            value: _vm.document.title,
            callback: function callback($$v) {
              _vm.$set(_vm.document, "title", $$v);
            },
            expression: "document.title"
          }
        })];
      },
      proxy: true
    }, {
      key: "subtitle",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "subtitle  mt-1 mb-n3",
          attrs: {
            "no-gutters": "",
            "justify": "center",
            "align": "center"
          }
        }, [_vm._v(" " + _vm._s(_vm.subtitle) + " "), _c('v-spacer'), _c('v-select', {
          staticClass: "mb-n2 mt-2",
          staticStyle: {
            "max-width": "90px"
          },
          attrs: {
            "dense": "",
            "items": [true, false]
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function fn(_ref) {
              var item = _ref.item;
              return [_c('small', [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.isTemplate.".concat(item))) + " ")])];
            }
          }, {
            key: "selection",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [_c('small', [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.isTemplate.".concat(item))) + " ")])];
            }
          }]),
          model: {
            value: _vm.document.isTemplate,
            callback: function callback($$v) {
              _vm.$set(_vm.document, "isTemplate", $$v);
            },
            expression: "document.isTemplate"
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('v-divider'), _c('div', {
    style: _vm.mainContainerStyle
  }, [_c('v-simple-table', [_c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.name")))]), _c('td', [_c('v-text-field', {
    staticClass: "mb-n2 ml-1",
    attrs: {
      "dense": ""
    },
    model: {
      value: _vm.name,
      callback: function callback($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1)]), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.path")))]), _c('td', [_c('v-text-field', {
    staticClass: "mb-n2 ml-1",
    attrs: {
      "dense": ""
    },
    model: {
      value: _vm.document.folder,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "folder", $$v);
      },
      expression: "document.folder"
    }
  })], 1)]), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t("sign.DocumentTemplateDetailInformation.tags")))]), _c('td', [_c('v-combobox', {
    staticClass: "mb-n2 ml-1",
    attrs: {
      "dense": "",
      "multiple": ""
    },
    model: {
      value: _vm.document.tags,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "tags", $$v);
      },
      expression: "document.tags"
    }
  })], 1)])])]), _c('v-card-text', {
    staticClass: "mt-1"
  }, [_c('v-textarea', {
    staticClass: "mb-n2 mt-n1",
    attrs: {
      "placeholder": _vm.$t('sign.DocumentTemplateDetailInformation.description'),
      "auto-grow": "",
      "dense": "",
      "rows": "1"
    },
    model: {
      value: _vm.document.description,
      callback: function callback($$v) {
        _vm.$set(_vm.document, "description", $$v);
      },
      expression: "document.description"
    }
  })], 1)], 1), _c('div', {
    staticClass: "ma-5 mb-3 mt-1"
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "success",
      "elevation": 0
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTemplateDetailSave.save")) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }